export default __webpack_public_path__ + "static/media/grid.fb5fcb0b.svg";